import { render, staticRenderFns } from "./RiskCorrelationsBlock.vue?vue&type=template&id=5920035e&scoped=true"
import script from "./RiskCorrelationsBlock.vue?vue&type=script&lang=js"
export * from "./RiskCorrelationsBlock.vue?vue&type=script&lang=js"
import style0 from "./RiskCorrelationsBlock.vue?vue&type=style&index=0&id=5920035e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5920035e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VCardText,VCol,VContainer,VRow,VSheet})
